<template lang="pug">
v-dialog(
  scrollable lazy
  v-model='dialog'
  max-width='500px'
)
  v-card
    //- 表單
    v-card-text(v-if='data')
      v-form(v-model='valid' :lazy-validation='true')
        v-text-field(label='簡章名稱 *' :rules='rules.name' v-model.trim='data.name' hint='檔案的描述' autofocus @keyup.enter='save')
        v-text-field(label='連結 *' :rules='rules.link' v-model.trim='data.link' hint='Google 雲端硬碟中已設定為連結共用的檔案 URL' placeholder='https://' @keyup.enter='save' clearable)

    v-divider

    //- 工具列
    v-card-actions
      v-spacer
      v-btn(flat @click='close') {{ $t('cancel') }}
      v-btn.primary--text(flat @click='save' :disabled='!valid') {{ $t('save') }}
</template>

<script>
import { formStatus } from '@/mixins/formStatus'
import Loader from '@/components/Loader.vue'

export default {
  name: 'EditManual',
  data () {
    this.rules = {
      name: [v => !!v || 'Name is required'],
      link: [
        v => !!v || 'Link is required',
        v => /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/.test(v) || 'Link should be a valid URL',
      ],
    }
    return {
      valid: true,
      index: null,
      data: null,
    }
  },
  methods: {
    edit (data, index) {
      const randomString = require('random-base64-string')

      this.data = null
      this.dialog = true
      this.index = index

      this.$nextTick(() => {
        this.data = (index === undefined)
          ? { name: '', link: '', _id: randomString(6) } // 新增的空物件
          : { ...data } // 拷貝原物件
      })
    },
    save () {
      if (!this.valid) return
      this.$emit('done', { ...this.data }, this.index)
      this.dialog = false
    },
  },
  components: {
    Loader,
  },
  mixins: [formStatus],
}
</script>
